import {requestMs} from "@helpers/api";

export const employees = {
  getEmployees: (query) => requestMs.get(`/api3/user/${query}`),
  getSingleEmployee: ({employeeId, userId}) => requestMs.get(`/api3/user/${userId}/drivers/extended?filterUserId=${employeeId}`, {}),
  getEmployeeCarChecks: ({employeeId, page}) => requestMs.get(`/api3/driver/${ employeeId }/carcheck?page=${ page || 0 }`),
  getEmployeeDamages: ({employeeId, page}) => requestMs.get(`/api3/driver/${ employeeId }/damage?page=${ page || 0 }`),
};
